/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getToken, withAppContext } from '@ctsu/loader';
import { GridTable, GridController } from '@ctsu/ctsu-mui-grid';
import { FasComment } from 'assets/icons';
import { ATCONSTANTS as ATC } from 'appconstants';
import { viewEmail } from 'actions/common';
import bindLogger from 'helpers/BindLogger';
import { bindActionCreators } from 'redux';
import { openConfirmation } from 'components/Confirmation/Confirmation';
import CommunicationMethod from 'components/EmailGenerator/CommunicationMethod';
import { dateFormatter } from 'helpers';
import CommentsNarrative from './CommentsNarrative';

const controller = GridController.createController();

const DATE_FORMAT = 'dd-MMM-yyyy';

const COLUMNS = [
  {
    name: 'commentType',
    label: 'Type',
    renderCell: (data) => {
      if (data.commentType != null) {
        return data.commentType === 'I' ? 'Int' : 'Ext';
      }
      return '';
    }
  },
  { name: 'commentSource', label: 'Source' },
  {
    name: 'comments',
    label: 'Comments',
    renderCell: (data, events) => {
      const onClick = () => events[0](data);
      return (
        <button
          data-id={`${ATC.PACKETID}${data.id}COMMENT${ATC.BUTTON}`}
          onClick={onClick}
          type="button"
          className="fn-btn font-lg mr-1"
          title="Comment Narrative"
        >
          <FasComment />
        </button>
      );
    }
  },
  { name: 'commentMethod', label: 'Method' },
  {
    name: 'id',
    label: 'ID',
    renderCell: (data, events) => {
      const { commentType, commentMethod, id } = data;
      const onClick = () => events[1](data);
      if (commentType === 'I' && commentMethod === 'EMAIL') {
        return (
          <button className="fn-btn" data-id={`${ATC.PACKETID}${id}_ID${ATC.LINK}`} type="button" onClick={onClick}>
            {id}
          </button>
        );
      }
      return id;
    }
  },
  { name: 'createdBy', label: 'Created By' },
  {
    name: 'createdDate',
    label: 'Created Date',
    renderCell: (data) => {
      const { createdDate } = data;
      if (createdDate != null) {
        return dateFormatter(createdDate, DATE_FORMAT);
      }
      return '';
    }
  }
];

function PacketCommunication(props) {
  const {
    context, packetComments = [], parentController, appliedFilters, status, additionalDetails, viewEmailAc
  } = props;
  useEffect(() => {
    controller.reload();
  }, [packetComments]);

  let modal;

  const cancelModel = () => {
    modal.handleClose();
  };
  const openCommunicator = (packetId, emailId, statusDt) => {
    modal = openConfirmation({
      header: 'Communicate - PACKET',
      isClose: true,
      fullscreen: 'Modal-fullscreen',
      renderComp: () => (
        <CommunicationMethod
          cancelCommunicationHanlder={cancelModel}
          controller={parentController}
          dbId={packetId}
          emailId={emailId}
          keyValue={status}
          sendDate={statusDt}
          appliedFilters={appliedFilters}
          additionalDetails={additionalDetails}
          tagName="PACKET_EMAIL_"
          orgType="PACKET_SCREENS"
          mode
        />
      )
    });
  };

  const onClickComment = () => {
    openConfirmation({
      header: `Comment Narrative`,
      renderComp: () => <CommentsNarrative packetComments={packetComments} />,
      secondBtn: 'Close'
    });
  };

  const onClickId = (data) => {
    bindLogger(viewEmailAc, context)(data.id);
    openCommunicator(data.packetId, data.id, data.createdDate);
  };

  const counts = packetComments.reduce(
    (acc, comment) => {
      const { commentMethod } = comment;
      if (commentMethod === 'EMAIL') {
        acc.email += 1;
      } else if (commentMethod === 'PHONE') {
        acc.phone += 1;
      }
      return acc;
    },
    {
      email: 0,
      phone: 0
    }
  );

  return (
    <div className="px-3 pb-3">
      <GridTable
        id="addDetails"
        tag={`${ATC.PACKETID}ADD_DETAILS_BROWSER${ATC.TABLE}`}
        rows={packetComments}
        controller={controller}
        columns={COLUMNS}
        rowEvents={[onClickComment, onClickId]}
        toPdf={false}
        getToken={getToken}
      />
      <div className="row justify-content-center">
        <div className="mr-4">
          <span className="color-dark-blue mr-1">Total Communications:</span>
          {' '}
          {counts.email + counts.phone}
        </div>
        <div className="mr-4">
          <span className="color-dark-blue mr-1">Email:</span>
          {' '}
          {counts.email}
        </div>
        <div className="">
          <span className="color-dark-blue mr-1">Phone:</span>
          {' '}
          {counts.phone}
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  packetComments: state.packet.packetComments
});

const withConnectState = connect(mapStateToProps, (dispatch) => bindActionCreators(
  {
    viewEmailAc: viewEmail
  },
  dispatch
));

export default withAppContext(withConnectState(PacketCommunication));
